module.exports = __webpack_public_path__ + "img/luk.e8b68013.svg";